import {
	AccountNumberText,
	DesignerNumberText,
	DoorStyleText,
	FinishText,
	JobNameText,
	OrderNumberText,
	OriginalOrderText,
	PONumberText,
	ProductLineText,
	UnavailableDataPlaceholderText
} from "constants/text";
import { displayDesigner } from "utils/order";
import {
	PlaceOrderOriginalOrderDetailsDetails,
	PlaceOrderOriginalOrderDetailsWrapper
} from "./PlaceOrderOriginalOrderDetails.styles";
import { models } from "types/api/viewModels";
import { getOrderAccountInfo, getOrderGlobals } from "pages/OrderPages/utils/OrderDetailUtil.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

export interface PlaceOrderOriginalOrderDetailsProps {
	orderDetail: models["OrderDetailViewModel"] | null | undefined;
	isAddOnLandingPage?: boolean;
}

const PlaceOrderOriginalOrderDetails = ({
	orderDetail,
	isAddOnLandingPage = false
}: PlaceOrderOriginalOrderDetailsProps) => {
	const { isReplacementsPage } = useUserLocation();
	const orderAccountInfo = getOrderAccountInfo(orderDetail);
	const orderGlobals = getOrderGlobals(orderDetail);

	const orderDetails = [
		{
			title: ProductLineText,
			value: orderGlobals?.[0]?.productLine?.description?.replaceAll("_", " "),
			dataTestId: "replacements-header-productLine"
		},
		{
			title: JobNameText,
			value: orderDetail?.jobName,
			dataTestId: "replacements-header-jobName"
		},
		{
			title: PONumberText,
			value: orderDetail?.poNumber,
			dataTestId: "replacements-header-poNumber"
		},
		{
			title: OrderNumberText,
			value: orderDetail?.orderNumber,
			dataTestId: "replacements-header-orderNumber"
		},
		{
			title: AccountNumberText,
			value: orderAccountInfo?.accountDisplay,
			dataTestId: "replacements-header-accountNumber"
		},
		{
			title: DesignerNumberText,
			value: displayDesigner(orderDetail?.designer),
			dataTestId: "replacements-header-designerNumber"
		},
		{
			title: DoorStyleText,
			value: orderGlobals?.map((global) => global?.style?.description),
			dataTestId: "replacements-header-doorStyle"
		},
		{
			title: FinishText,
			value: orderGlobals?.map((global) => global?.finish?.description),
			dataTestId: "replacements-header-finish"
		}
	];

	return (
		<PlaceOrderOriginalOrderDetailsWrapper
			isAddOnLandingPage={isAddOnLandingPage || isReplacementsPage}
			data-testid="place-order-original-order-details"
		>
			{(isAddOnLandingPage || isReplacementsPage) && <span>{OriginalOrderText.toUpperCase()}</span>}
			<PlaceOrderOriginalOrderDetailsDetails isAddOnLandingPage={isAddOnLandingPage || isReplacementsPage}>
				{orderDetails.map((detail) => (
					<div key={detail.title}>
						<span>{detail.title}</span>
						{!Array.isArray(detail.value) ? (
							<span data-testid={detail.dataTestId}>
								{detail.value ?? UnavailableDataPlaceholderText}
							</span>
						) : (
							<>
								{detail.value.map((val) => (
									<span
										key={val}
										data-testid={detail.dataTestId}
									>
										{val ?? UnavailableDataPlaceholderText}
									</span>
								))}
								{detail?.value?.length === 0 && (
									<span data-testid={detail.dataTestId}>{UnavailableDataPlaceholderText}</span>
								)}
							</>
						)}
					</div>
				))}
			</PlaceOrderOriginalOrderDetailsDetails>
		</PlaceOrderOriginalOrderDetailsWrapper>
	);
};

export default PlaceOrderOriginalOrderDetails;
